<script setup lang="ts">
/**
 * Generic 401 Unauthorized error page.
 *
 * Shown by the Axios response interceptor when it receives an HTTP 401 that
 * doesn't map to a more specific BFF error code. The explanation is built
 * from the backend message forwarded in `route.query.backendMessage` via
 * `unauthorizedExplanation`. Shows a "Go To Login" button.
 */

import { computed } from 'vue'

import { useRoute } from 'vue-router'

import ErrorView from '@/components/errors/ErrorView.vue'

import { redirectToLogin } from '@/api/keycloak_api'

import { ErrorCode } from '@/errors/codes'

import { ERROR_USER_MESSAGES, unauthorizedExplanation } from '@/errors/error_user_messages'

const route = useRoute()

const page = ERROR_USER_MESSAGES[ErrorCode.Unauthorized]

const title = page.title

const explanation = computed(() => unauthorizedExplanation(route.query.backendMessage))

const actions = page.actions ?? []

function goToLogin() {
  redirectToLogin()
}
</script>

<template>
  <ErrorView
    :code="ErrorCode.Unauthorized"
    :title="title"
    :explanation="explanation"
    :actions="actions"
  >
    <button class="tufte-button" @click="goToLogin">Go To Login</button>
  </ErrorView>
</template>
